import React, { useState } from "react";
import { useUser } from "../../context/UserContext";
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Flex,
  VStack,
  Container,
  Stack,
  keyframes,
  Circle,
  Avatar,
  Icon,
  Text,
  HStack
} from "@chakra-ui/react";
import { PasswordField } from "../../components/auth/passwordField";
import logo from "../../assets/logo_dark_small.png";
import { PiSignIn } from "react-icons/pi";
import { IoWarningOutline } from "react-icons/io5";

/*props for the UserLogin component*/
interface UserLoginProps { }
const rotateAnimation = keyframes`
  0% { transform: rotate(0deg); }
  85% { transform: rotate(0deg); }
  100% { transform: rotate(120deg); }
`;

const UserLogin: React.FC<UserLoginProps> = () => {
  const animation = `${rotateAnimation} 3s linear infinite`;
  /* Accessing login function from the user context*/
  const { login, errorMsg } = useUser();

  /* State variables to manage username and password*/
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  /*Function to handle form submission*/
  const handleSubmit = (event: any) => {
    event.preventDefault();
    /* Calling login function from context with username and password*/
    login(username, password);
  };

  return (
    <Flex
      minHeight="100vh"
      width="full"
      align="center"
      justifyContent="center"
      bgGradient="linear(to-b, purple.50, purple.100)"
    >
      <Container maxW="xl">
        <VStack spacing={2} width="100%">
          <HStack spacing={3}>
            <Circle color="fg.default" p={1} m={1}
              border="4px solid"
              borderColor="purple.700">
              <Avatar
                size="lg"
                src={logo}
                animation={animation}
                name="Anko"
                color="black"
              />
            </Circle>
            <Text fontSize="5xl" fontWeight="400" mb={0} color="purple.700">Anko</Text>
          </HStack>
          <Text fontSize="md" fontWeight="500" mb={0} color="purple.700"> Sign in to access your Analysts</Text>
          <VStack
            width="100%"
            bg="bg.surface"
            spacing={3}
            p={9}
            m={3}
            boxShadow="lg"
            borderRadius="xl"
            gap={0}
          >
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <Stack spacing="9" bg="bg.surface" width="100%">
                <FormControl colorScheme="purple">
                  <FormLabel htmlFor="email" fontSize="md" color="fg.muted">Email</FormLabel>
                  <Input
                    id="email"
                    type="email"
                    size="lg"
                    colorScheme="purple"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </FormControl>
                <PasswordField
                  size="lg"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  colorScheme="purple"
                />
                {errorMsg && (
                  <HStack
                    spacing={2}
                    align="flex-start"
                  >
                    <Icon as={IoWarningOutline} color="red.500" boxSize={5} mt="1px" />
                    <Text fontSize="sm" color="red.500" fontWeight="medium">
                      {errorMsg}
                    </Text>
                  </HStack>
                )}
                <Button
                  type="submit"
                  bg="purple.700"
                  color="white"
                  colorScheme="purple"
                  size="lg"
                  mt={2}
                  width="full"
                  _hover={{ bg: "purple.600", color: "white" }}
                  border="1px solid"
                  borderColor="purple.700"
                >
                  <Icon as={PiSignIn} mr={2} />
                  Continue
                </Button>
              </Stack>
            </form>
          </VStack>
        </VStack>
      </Container>
    </Flex>
  );
};

export default UserLogin;